/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetPressReleaseHistorySuccessResponsePressReleaseHistory,
    GetPressReleaseHistorySuccessResponsePressReleaseHistoryFromJSON,
    GetPressReleaseHistorySuccessResponsePressReleaseHistoryFromJSONTyped,
    GetPressReleaseHistorySuccessResponsePressReleaseHistoryToJSON,
} from './GetPressReleaseHistorySuccessResponsePressReleaseHistory';

/**
 * GET /press_release/{release_id}/history/{release_history_id}
 * @export
 * @interface GetPressReleaseHistorySuccessResponse
 */
export interface GetPressReleaseHistorySuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof GetPressReleaseHistorySuccessResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof GetPressReleaseHistorySuccessResponse
     */
    message: string;
    /**
     * 
     * @type {GetPressReleaseHistorySuccessResponsePressReleaseHistory}
     * @memberof GetPressReleaseHistorySuccessResponse
     */
    pressReleaseHistory: GetPressReleaseHistorySuccessResponsePressReleaseHistory;
}

export function GetPressReleaseHistorySuccessResponseFromJSON(json: any): GetPressReleaseHistorySuccessResponse {
    return GetPressReleaseHistorySuccessResponseFromJSONTyped(json, false);
}

export function GetPressReleaseHistorySuccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPressReleaseHistorySuccessResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'pressReleaseHistory': GetPressReleaseHistorySuccessResponsePressReleaseHistoryFromJSON(json['press_release_history']),
    };
}

export function GetPressReleaseHistorySuccessResponseToJSON(value?: GetPressReleaseHistorySuccessResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'press_release_history': GetPressReleaseHistorySuccessResponsePressReleaseHistoryToJSON(value.pressReleaseHistory),
    };
}

